import { render, staticRenderFns } from "./_marketplace.vue?vue&type=template&id=032d6013"
import script from "./_marketplace.vue?vue&type=script&lang=js"
export * from "./_marketplace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports